import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { env } from "@/env";
import { useFormsortEmbedTheme } from "@/hooks/use-formsort-embed-theme";

const CustomQuestionsLayout = () => {
  useFormsortEmbedTheme();

  return <Outlet />;
};

export const Route = createFileRoute("/_guest/profiling/_custom-questions")({
  beforeLoad: () => {
    if (env.VITE_APP_ENV !== "local" && window.self === window.top) {
      throw redirect({ to: "/profiling" });
    }
  },
  component: CustomQuestionsLayout,
});
